meedy.controller('meedy.videoConsultationTestController', ['$rootScope', '$scope', '$sce', '$state', '$stateParams', '$timeout', '$mdDialog', '$window', 'objectHelper', 'applicationModel', 'visitModel', 'OTSession',
    function ($rootScope, $scope, $sce, $state, $stateParams, $timeout, $mdDialog, $window, objectHelper, applicationModel, visitModel, OTSession) {

        function setData() {
            $scope.physicianWidth = 800;
            $scope.physicianHeight = 600;

            $scope.recording = false;
            $scope.recordURL = null;

            $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.STAND_BY;

            $scope.screen = angular.element("#screen");
            $scope.w = angular.element($window);

            if(typeof InstallTrigger !== 'undefined') {
                $scope.mediaConstraints = {
                    audio: !!navigator.mozGetUserMedia,
                    video: true
                };
            } else {
                $scope.mediaConstraints = {
                    audio: true,
                    video: true
                };
            }
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                $scope.stop();
                applicationModel.viewReady = false;
            });

        }

        function setActions() {

            $scope.stopAnyDevice = function() {
                $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.STAND_BY;
                var MediaStream = window.MediaStream;

                if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
                    MediaStream = webkitMediaStream;
                }

                /*global MediaStream:true */
                if (typeof MediaStream !== 'undefined' && !('stop' in MediaStream.prototype)) {
                    MediaStream.prototype.stop = function() {
                        this.getAudioTracks().forEach(function(track) {
                            track.stop();
                        });

                        this.getVideoTracks().forEach(function(track) {
                            track.stop();
                        });
                    };
                }
            };

            $scope.trustSrc = function(src) {
                return $sce.trustAsResourceUrl(src);
            };

            $scope.onMediaSuccess = function(stream) {
                var video = $("#screen")[0];

                $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.RECORDING;

                video = mergeProps(video, {
                    controls: true,
                    muted: true,
                    src: URL.createObjectURL(stream)
                });

                video.width = $scope.physicianWidth;
                video.height = $scope.physicianHeight;

                video.addEventListener('loadedmetadata', function () {
                    $scope.multiStreamRecorder = new MultiStreamRecorder(stream);
                    $scope.multiStreamRecorder.stream = stream;

                    // below line is optional
                    // because we already set "video.width"
                    // and "video.height"....5 lines above
                    $scope.multiStreamRecorder.canvas = {
                        width: video.width,
                        height: video.height
                    };

                    $scope.multiStreamRecorder.video = video;

                    $scope.multiStreamRecorder.ondataavailable = function (blobs) {
                        var blobURL = URL.createObjectURL(blobs.audio);
                        //window.open(blobURL);
                        $timeout(function() {
                            $scope.recordURL = blobURL;
                        });

                    };

                    $scope.multiStreamRecorder.start(9999999); // 15 seconds

                }, false);

                video.play();
            };

            $scope.onMediaError = function(e) {
                console.error('media error', e);
            };

            $scope.goToHome = function() {
                $state.go(Constant.STATE.APP.MEEDY.HOME);
            };

            $scope.connect = function() {
                $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.STREAMING;
            };

            $scope.start = function() {
                $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.RECORDING;
                $scope.recorded = false;

                if (navigator.webkitGetUserMedia) {
                    navigator.webkitGetUserMedia($scope.mediaConstraints, $scope.onMediaSuccess, $scope.onMediaError);
                } else if (navigator.mozGetUserMedia) {
                    navigator.mozGetUserMedia($scope.mediaConstraints, $scope.onMediaSuccess, $scope.onMediaError);
                } else if (navigator.msGetUserMedia) {
                    navigator.msGetUserMedia($scope.mediaConstraints, $scope.onMediaSuccess, $scope.onMediaError);
                } else if(navigator.getUserMedia) {
                    navigator.getUserMedia($scope.mediaConstraints, $scope.onMediaSuccess, $scope.onMediaError);
                } else {
                    alert('getUserMedia() is not supported in your browser');
                }
            };

            $scope.stop = function() {
                $scope.state = Enum.MEEDY.VIDEO_CONSULTATION_TEST.STAND_BY;
                $scope.recorded = true;

                if($scope.multiStreamRecorder) {
                    $scope.multiStreamRecorder.stop();

                    if($scope.multiStreamRecorder.stream && $scope.multiStreamRecorder.stream.stop) {
                        $scope.multiStreamRecorder.stream.stop();
                    }
                }

                $scope.stopAnyDevice();
            };

            $scope.getWindowDimensions = function () {
                return {
                    'h': window.innerHeight,
                    'w': window.innerWidth
                };
            };

            $scope.$watch($scope.getWindowDimensions, function (newValue, oldValue) {
                $scope.windowHeight = newValue.h;
                $scope.windowWidth = newValue.w;

                $scope.style = function () {
                    return {
                        'height': (newValue.h - 100) + 'px',
                        'width': (newValue.w - 100) + 'px'
                    };
                };

            }, true);

            $scope.w.bind('resize', function () {
                $scope.$apply();
            });

        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setListeners();
        setActions();
        initialize();

    }
]);
